/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty, isEqual, isNull } from "lodash";
import React, { useEffect, useState } from "react";
import { deleteBanksTransClients, deleteBanksTransItems, getBankTransRecordDetail, modifyBankTransRecords } from "../../../apis/finances/bank";
import Button from "../../../components/Button";
import IconButton from "../../../components/Button/IconButton";
import DataComponent from "../../../components/DataComponent";
import Modal, { ModalHeader } from "../../../components/Modal";
import { ControlTable } from "../../../components/Table";
import { accountName } from "../../../utils/account-name";
import { dateToFormat } from "../../../utils/date";
import { viewLoading } from "../../../utils/loading";
import { autoHyphen } from "../../../utils/replace";
import systemAlert from "../../../utils/systemAlert";
import RelatedModal from "./RelatedModal";
import DeleteIcon from "../../../assets/images/icon/delete-icon-01.svg";
import Comment from "../../../components/Comment";
import { classnames } from "../../../utils/text";
import { useSelector } from "react-redux";

const BankDetail = ({ open, setOpen, formData, permission, listSubmit, type, careCompanyIdx }) => {
  const [fields, setFields] = useState();
  // 연관 세금계산서 리스트
  const [taxInvoiceFields, setTaxInvoiceFields] = useState([]);
  const [taxInvoiceList, setTaxInvoiceList] = useState([]);
  const [paperTaxInvoiceList, setPaperTaxInvoiceList] = useState([]);
  // 연관 거래명세서 리스트
  const [tradeInvoiceFields, setTradeInvoiceFields] = useState();
  const [tradeInvoiceList, setTradeInvoiceList] = useState([]);
  // 연관 카드내역 리스트
  const [cardFields] = useState([
    { title: "거래일자", key: "trDate", type: "date" },
    { title: "지급예정일", key: "payDate", type: "date" },
    { title: "카드사", key: "cardCompany1" },
    { title: "결제금액", key: "buyAmt", type: "comma" },
    { title: "수수료", key: "totalCommAmt", type: "comma" },
    { title: "지급예정액", key: "payAmt", type: "comma" },
  ]);
  const [cardList, setCardList] = useState([]);
  // 연관 현금영수증 리스트
  const [cashFields, setCashFields] = useState([]);
  const [cashList, setCashList] = useState([]);
  // 연관 데이터 오픈
  const [relatedListOpen, setRelatedListOpen] = useState(false);
  const [data, setData] = useState({});
  const [originData, setOriginData] = useState({});
  // 연관 항목 권한
  const [targetPermission, setTargetPermission] = useState([]);
  const { permissions } = useSelector((store) => ({
    permissions: store.Profile.permissions
  }));

  useEffect(() => {
    setFields([
      [
        {
          title: "거래일자",
          key: "tradeTime",
          onValue: (value) => {
            return dateToFormat(value, "YYYY.MM.DD");
          },
        },
        ...(type === "bank" ? [{
          title: "계좌정보",
          key: "bankName",
          onValue: (value, field, data) => {
            return accountName(data.bankName, data.bankAccountNo);
          },
        }] : []),
        {
          title: "입금액", key: "inAmt", className: 'color-red-100', type: "comma"
        },
        {
          title: "출금액", key: "outAmt", className: 'color-purple-100', type: "comma"
        },
        { title: "거래자명", key: "traderName" },
        { title: "입금자명", key: "sendBankAccountHolder" },
      ],
      [

        {
          title: "메모", key: "memo",
          // ...(type === "bank" ? {} : {
          //   type: 'input',
          //   onChange: (e) => {
          //     setData({
          //       ...data,
          //       memo: e.target.value
          //     });
          //   }
          // })
        },

        ...(type === "bank" ? [
          {
            title: "적요", key: "remark", type: 'input', onChange: (e) => {
              setData({
                ...data,
                remark: e.target.value
              });
            }
          },
          {
            title: "적요(상세)", key: "detail", type: 'input', onChange: (e) => {
              setData({
                ...data,
                detail: e.target.value
              });
            }
          }
        ] : []),
        {
          title: "거래처",
          key: "clients",
          onValue: (value, field, data) => {
            return (
              !isEmpty(value) &&
              value.map((client, idx) => (
                <p className="pt-8 pb-8" key={idx}>
                  <span className="vertical-middle">{client.name}</span>
                  {permission.level > 1 && (
                    <IconButton className="ml-4 vertical-middle" icon={DeleteIcon} action={() => handleRemoveClient(data, client)} />
                  )}
                </p>
              ))
            );
          }
        },
      ]
    ]);
  }, [data]);

  const cancel = (e) => {
    if (e) e.preventDefault();
    setOpen(false);
    // 연관항목 초기화
    setTaxInvoiceList([]);
    setPaperTaxInvoiceList([]);
    setTradeInvoiceList([]);
    setCardList([]);
    setCashList([]);
    setData({});
    setOriginData({});
  };

  useEffect(() => {
    if (open) {
      // 관련항목 권한체크
      const permissionTarget = ['TAX_INVOICE', 'TRADE_INVOICE', 'CASH_INVOICE', 'FUND_CARD_HISTORY'];
      const targetPermissions = permissions.filter((p) => permissionTarget.includes(p.code));
      setTargetPermission(targetPermissions);
    }
  }, [permissions, open]);

  useEffect(() => {
    // 세금계산서 필드
    setTaxInvoiceFields([
      { title: "일자", key: "writeDate", type: 'date' },
      { title: "상호", key: formData.inAmt > 0 ? "byrCorpName" : "supCorpName" },
      { title: "대표자명", key: formData.inAmt > 0 ? "byrRepName" : "supRepName" },
      {
        title: "사업자번호",
        key: formData.inAmt > 0 ? "byrBizNo" : "supBizNo",
        onValue: (value) => {
          return autoHyphen("comNum", value);
        },
      },
      {
        title: "공급가액",
        key: "supplyAmt",
        type: 'comma'
      },
      {
        title: "세액",
        key: "taxAmt",
        type: 'comma'
      },
      {
        title: "합계금액",
        key: "totalAmt",
        type: 'comma'
      },
    ]);
    // 거래명세서 필드
    setTradeInvoiceFields([
      { title: "일자", key: "writeDate", type: 'date' },
      { title: "상호", key: formData.inAmt > 0 ? "byrCorpName" : "supCorpName" },
      { title: "대표자명", key: formData.inAmt > 0 ? "byrRepName" : "supRepName" },
      {
        title: "사업자번호",
        key: formData.inAmt > 0 ? "byrBizNo" : "supBizNo",
        onValue: (value) => {
          return autoHyphen("comNum", value);
        },
      },
      {
        title: "공급가액",
        key: "supplyAmt",
        type: 'comma'
      },
      {
        title: "세액",
        key: "taxAmt",
        type: 'comma'
      },
      {
        title: "합계금액",
        key: "totalAmt",
        type: 'comma'
      },
      {
        title: "발행여부",
        key: "taxInvoiceIdx",
        onValue: (value, field, form) => {
          let issue = "";
          if (isNull(value)) {
            issue = "부";
          } else {
            // TODO 나중에 현금영수증 발급 추가 될 경우... 변경해야함
            issue = "세금계산서";
          }

          return issue;
        },
      },
    ]);
    // 현금영수증 필드
    setCashFields([
      { title: "일자", key: "tradeTime", type: 'date' },
      { title: "승인번호", key: "apprNo" },
      { title: "발급수단번호", key: "frPartNo" },
      { title: formData.inAmt > 0 ? "거래구분" : "공제구분", key: formData.inAmt > 0 ? "trGb" : "ddcYn" },
      { title: "공급가액", key: "supAmt" },
      { title: "부가세", key: "taxAmt" },
      { title: "봉사료", key: "tip" },
      { title: "총 거래금액", key: "totAmt" },
    ]);
  }, [formData]);

  useEffect(() => {
    if (open) {
      submit();
    }
  }, [open, formData]);

  const submit = () => {
    viewLoading(true);
    getBankTransRecordDetail(formData.idx, careCompanyIdx).then((res) => {
      const { invoices, taxInvoices, cardSales, cashReceiptPurchases, cashReceiptSales } = res.data;
      res.data = {
        ...res.data,
        inAmt: String(res.data.inAmt),
        outAmt: String(res.data.outAmt)
      };

      const paperTaxInvoices = taxInvoices.filter(f => f.invoiceType === "paper_tax_invoice");

      setData(res.data);
      setOriginData(res.data);
      setTaxInvoiceList(taxInvoices.filter(f => f.invoiceType !== "paper_tax_invoice"));
      setPaperTaxInvoiceList(paperTaxInvoices);
      setTradeInvoiceList(invoices);
      setCardList(cardSales);
      if (formData.inAmt > 0) {
        setCashList(cashReceiptSales);
      }
      if (formData.outAmt > 0) {
        setCashList(cashReceiptPurchases);
      }
    }).finally(() => viewLoading(false));
  };

  const handleRemoveClient = (data, client) => {
    const bankIdx = data.idx;
    const clientIdx = client.idx;

    systemAlert(`은행내역에 매핑된 거래처(${client.name})를 삭제하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '확인',
          onClick: () => {
            deleteBanksTransClients(bankIdx, clientIdx)
              .then(() => {
                submit();
              })
              .catch(() => { })
              .finally(() => { });
          }
        }
      ]
    });
  };

  const rowBtnConfig = {
    rowButtons: [
      {
        label: "삭제",
        type: "delete",
        className: "margin-right-8",
        action: (rowData) => {
          systemAlert('해당 연관 데이터를 삭제하시겠습니까?', {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '삭제',
                onClick: () => {
                  viewLoading(true);
                  deleteBanksTransItems(rowData.bankTransItem.idx).then(() => { submit(); }).catch(() => { }).finally(() => viewLoading(false));
                }
              }
            ]
          });
        },
      },
    ],
  };

  const totalSubmit = () => {
    submit();
    listSubmit();
  };

  const handleOnClick = () => {
    const body = {
      ...(type === "bank" ? {} : {
        memo: data.memo
      }),
      remark: data.remark,
      detail: data.detail,
    };

    systemAlert('적요를 수정하시겠습니까?', {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '수정',
          onClick: () => {
            modifyBankTransRecords(data.idx, body).then((res) => {
              totalSubmit();
            });
          }
        }
      ]
    });
  };

  return (
    <>
      <Modal isOpen={open} close={cancel}>
        <div className="bank-summaries-detail">
          <ModalHeader>{`${type === "bank" ? "은행 입출금 내역" : "현금 계좌"} 상세`}</ModalHeader>
          {type === "bank" && <Button className="edit-button" label={"적요수정"} onClick={handleOnClick} color="line" disabled={isEqual(data, originData)} />}
          <table className="bank-detail-table">
            <thead>
              <tr>
                {!isEmpty(fields) &&
                  fields[0].map((field, idx) => <th key={idx}>{field.title}</th>)}
              </tr>
            </thead>
            <tbody>
              <tr>
                {!isEmpty(fields) &&
                  fields[0].map((field, idx) => (
                    <td key={idx} className={classnames("vertical-align-middle", field.className)}>
                      <DataComponent field={field} form={data} data={data} />
                    </td>
                  ))}
              </tr>
            </tbody>
          </table>

          <table className="bank-detail-table mt-10">
            <thead>
              <tr>
                {!isEmpty(fields) &&
                  fields[1].map((field, idx) => <th key={idx}>{field.title}</th>)}
              </tr>
            </thead>
            <tbody>
              <tr>
                {!isEmpty(fields) &&
                  fields[1].map((field, idx) => (
                    <td key={idx} className={classnames("vertical-align-middle", field.className)}>
                      <DataComponent field={field} form={data} data={data} />
                    </td>
                  ))}
              </tr>
            </tbody>
          </table>

          <div className="related-container">
            {permission.level > 1 && (
              <div className="related-header">
                <Button
                  className="add-related-btn"
                  size="sm"
                  color="line"
                  label="관련항목 추가"
                  disabled={isEmpty(targetPermission)}
                  onClick={() => setRelatedListOpen(true)}
                />
              </div>
            )}
            {!isEmpty(taxInvoiceList) && (
              <div className="related-body">
                <label className="related-header-title">
                  연관 전자(세금)계산서
                </label>
                <ControlTable fields={taxInvoiceFields} list={taxInvoiceList} rowBtn={permission.level > 1 ? rowBtnConfig : {}} />
              </div>
            )}
            {!isEmpty(paperTaxInvoiceList) && (
              <div className="related-body">
                <label className="related-header-title">
                  연관 종이(세금)계산서
                </label>
                <ControlTable fields={taxInvoiceFields} list={paperTaxInvoiceList} rowBtn={permission.level > 1 ? rowBtnConfig : {}} />
              </div>
            )}
            {!isEmpty(tradeInvoiceList) && (
              <div className="related-body">
                <label className="related-header-title">
                  연관 거래명세서
                </label>
                <ControlTable fields={tradeInvoiceFields} list={tradeInvoiceList} rowBtn={permission.level > 1 ? rowBtnConfig : {}} />
              </div>
            )}
            {!isEmpty(cardList) && (
              <div className="related-body">
                <label className="related-header-title">
                  연관 카드 매출 내역
                </label>
                <ControlTable fields={cardFields} list={cardList} rowBtn={permission.level > 1 ? rowBtnConfig : {}} />
              </div>
            )}
            {!isEmpty(cashList) && (
              <div className="related-body">
                <label className="related-header-title">
                  연관 현금영수증 내역
                </label>
                <ControlTable fields={cashFields} list={cashList} rowBtn={permission.level > 1 ? rowBtnConfig : {}} />
              </div>
            )}
          </div>
          <div className="margin-top-24">
            <Comment
              postIdx={formData.idx}
              postType="bank_trans"
              submit={listSubmit}
            />
          </div>
          <div className="margin-top-20">
            <Button className="close-button" label="닫기" onClick={cancel} />
          </div>
        </div>
      </Modal>
      <RelatedModal
        open={relatedListOpen}
        setOpen={setRelatedListOpen}
        bankData={[formData]}
        submit={totalSubmit}
        permissions={targetPermission}
        fields={fields}
      />
    </>
  );
};

export default BankDetail;
